const GradeIncreaseConfirmModal = ({ onConfirm, onCancel }) => {
  const styles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      color: "#000",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
    },
    modalContent: {
      backgroundColor: "#fff",
      padding: "20px",
      borderRadius: "8px",
      width: "300px",
      maxWidth: "90%",
    },
    modalHeader: {
      textAlign: "center",
      fontSize: "16px",
      marginBottom: "40px",
    },
    modalBody: {
      marginBottom: "40px",
    },
    modalFooter: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    dangerButton: {
      backgroundColor: "#FF4444",
      color: "#fff",
      border: "none",
      padding: "6px 12px",
      width: "100%",
      cursor: "pointer",
      borderRadius: "4px",
    },
    cancelButton: {
      backgroundColor: "#EBEBEB",
      color: "#737373",
      border: "none",
      padding: "6px 12px",
      cursor: "pointer",
      width: "100%",
      borderRadius: "4px",
    },
  };

  return (
    <div style={styles.modalOverlay} onClick={onCancel}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div style={styles.modalHeader}>학년 일괄 증가</div>
        <div style={styles.modalBody}>
          <p style={{ textAlign: "center" }}>
            <strong>정말 학년을 일괄 증가하시겠습니까?</strong>
          </p>
          <p style={{ textAlign: "center", fontSize: "14px", color: "#737373" }}>
            이 작업은 되돌릴 수 없습니다.
          </p>
        </div>
        <div style={styles.modalFooter}>
          <button style={styles.dangerButton} onClick={onConfirm}>
            네
          </button>
          <button style={styles.cancelButton} onClick={onCancel}>
            아니오
          </button>
        </div>
      </div>
    </div>
  );
};

export default GradeIncreaseConfirmModal;
